import MeetingRoomIcon from "../../../assets/icons/meeting-room.svg"
import MeetingRoomSelectedIcon from "../../../assets/icons/meeting-room-selected.svg"
import FlexdaySuiteIcon from "../../../assets/icons/flexday-suite.svg"
import FlexdaySuiteSelectedIcon from "../../../assets/icons/flexday-suite-selected.svg"
import PrivateOfficeIcon from "../../../assets/icons/private-office.svg"
import PrivateOfficeSelectedIcon from "../../../assets/icons/private-office-selected.svg"

export const markerIcons = {
  "Meeting Room": {
    icon: MeetingRoomIcon,
    selected: MeetingRoomSelectedIcon,
  },
  "Flexday Suite": {
    icon: FlexdaySuiteIcon,
    selected: FlexdaySuiteSelectedIcon,
  },
  "Private Office": {
    icon: PrivateOfficeIcon,
    selected: PrivateOfficeSelectedIcon,
  },
}
